import { isTagadaPay } from '@/config/branding';
import { useResellerPartner } from '@/hooks/use-reseller-partner';

/**
 * Whether the Tagada referral / affiliate program should be exposed.
 *
 * The referral feature is hard-wired to Tagada-owned destinations
 * (app.tagada.io, tagada.io, tagadapay.io). It must never
 * appear under a partner **brand** — otherwise merchants would see Tagada
 * links while the CRM looks like the partner.
 *
 * Disabled when EITHER:
 *  - the resolved brand is not tagadapay — covers full whitelabel forks
 *    (VITE_BRAND/VITE_APP_NAME) and partner-mode hosts (e.g. app.payoren.com),
 *    see `isTagadaPay` in config/branding.
 *  - the active org is a **known branded reseller** on the tagada domain
 *    (`resellerPartners()`, injected by the middleware), where UI chrome
 *    is partner-skinned even though `isTagadaPay` is still true.
 *
 * Not disabled merely because `publicMetadata.whitelabel` is set for partner
 * **attribution** (e.g. verasolutions). Those orgs keep Tagada branding and
 * must still see Earn Money if they are referrers (TAG-1715).
 */
export function useReferralEnabled(): boolean {
  const resellerPartner = useResellerPartner();

  if (!isTagadaPay) return false;
  if (resellerPartner) return false;

  return true;
}
